import Modal from "react-bootstrap/Modal";

function DeleteModal({ show, handleClose, deleteFile, file, index }) {
  return (
    <Modal
      show={show}
      centered
      onHide={handleClose}
      size="sm"
      className="delete-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <div className="ionbx">
            <img src="/images/bin.svg" alt="dustbin" />
          </div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="pt-0">
        <div className="modal-headerd">
          This file is being shared along with the associated context.
        </div>
        <div className="deltemsg">Do you still want to remove?</div>
      </Modal.Body>
      <Modal.Footer className="justify-content-center flex-nowrap border-0 pt-3">
        <button className="cancelbtn" onClick={handleClose}>
          Cancel
        </button>
        <button
          className="deletebtn"
          onClick={() => {
            deleteFile(file, index);
            handleClose();
          }}
        >
          Remove
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default DeleteModal;
